import { useEffect, useMemo, useState } from 'react';

export const useClientTable = (rows = [], { initialPageSize = 10 } = {}) => {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(initialPageSize);

  const total = rows.length;

  useEffect(() => {
    setPage(0);
  }, [total, pageSize]);

  const pageCount = Math.max(1, Math.ceil(total / pageSize));
  const safePage = Math.min(page, pageCount - 1);

  const pageRows = useMemo(
    () => rows.slice(safePage * pageSize, safePage * pageSize + pageSize),
    [rows, safePage, pageSize]
  );

  return { page: safePage, setPage, pageSize, setPageSize, pageRows, pageCount };
};

export default useClientTable;
